

function Impressum() {
  return <div className="main-wrapper">
    
      

      <h1>Impressum</h1>

      <p>
        Solveig Marita Bissinger<br/>
        Jella-Lepman-Straße 22<br/>
        81673 München<br/>
        <br/>
        Telefon: <a href="tel:+49 89 43630078">+49 89 43630078</a><br/>
        E-Mail: <a href="mailto:info@tanztherapie-muenchen.de">info@solveig-bissinger.de</a><br/>
      </p>

      {/* <h3>Umsatzsteuer</h3>

      <p>
        Die Tätigkeit als Leiterin für Kreativen Tanz & Heilsame Bewegung ist nach § 19 Umsatzsteuergesetz (UStG) von der Umsatzsteuer befreit.
      </p> */}

      <h3>Quellenangaben für die verwendeten Bilder und Grafiken</h3>

      <p>
        Jorma Bissinger<br/>
        Solveig Marita Bissinger<br/>
        <br/>
        Alle verwendeten Bilder sind urheberrechtlich geschützt und dürfen nicht verwendet oder weitergegeben werden.<br/>
      </p>

      <h3>Webdesign & Entwicklung</h3>

      <p>
        VUESTE<br/>
        <a href="https://vueste.de" target="_blank" rel="noopener noreferrer">vueste.de</a>
      </p>

      <h3>Haftungsausschluss</h3>

      <p>
        Haftung für Inhalte:<br/>
        Die Inhalte meiner Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte übernehme ich jedoch keine Gewähr.

      </p>

      <p>
        Haftung für Links:<br/>
        Meine Webseite enthält Links zu externen Webseiten Dritter, auf deren Inhalte ich keinen Einfluss habe. Deshalb übernehme ich für diese fremden Inhalte keine Gewähr. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
      </p>

    </div>
}
export default Impressum;